import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import logoJotabe from "@/assets/logo-jotabe.png";
import HeroVideoPlayer from "./HeroVideoPlayer";

const CapitalHero = () => {
  return (
    <section
      id="hero"
      className="relative flex items-center justify-center overflow-hidden bg-[#0a1628] pt-32 pb-20 md:pt-40 md:pb-28"
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 70% 70% at 20% 0%, rgba(37, 99, 235, 0.28) 0%, transparent 70%)",
        }}
      />

      <div className="container relative z-10 px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-4xl mx-auto text-center"
        >
          <img
            src={logoJotabe}
            alt="Distribuidora JotaBe S.A."
            className="h-10 md:h-14 mx-auto mb-10 w-auto"
          />

          <span className="inline-block text-[#60a5fa] text-[11px] md:text-xs tracking-[0.24em] font-semibold mb-6">
            PROPUESTA · CORESSEN CAPITAL®
          </span>

          <h1 className="font-display text-[2.1rem] leading-[1.08] md:text-6xl font-bold text-white tracking-tight">
            Que tu marca represente el{" "}
            <span className="text-[#60a5fa]">verdadero nivel</span> de la empresa que construyeron.
          </h1>

          <p className="mt-7 text-white/70 text-base md:text-xl leading-relaxed max-w-3xl mx-auto">
            En 60 días, JotaBe pasa de tomar decisiones de marca fragmentadas a contar con una
            posición definida, una percepción objetivo y prioridades estratégicas claras para
            construir Capital de Marca con dirección y coherencia.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button size="xl" asChild>
              <a href="#inversion">Ver la propuesta</a>
            </Button>
            <p className="text-white/50 text-sm">{"\n"}</p>
          </div>

          <div className="mt-14 max-w-3xl mx-auto">
            <HeroVideoPlayer />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CapitalHero;
